import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserAuthorityMapping = React.lazy(() =>
    import('../UserAuthorityMapping')
);
const userAuthorityMappingRoutesRegistry = [
    {
        path: PAGE_URL.USER_AUTHORITY_MAPPING_PAGE,
        element: <UserAuthorityMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userAuthorityMappingRoutesRegistry;
